export default __webpack_public_path__ + "static/media/education.b1d99f21.jpg";